import { vehicleClasses } from "./Constants";

export const getVehicleClassData = (id) => {
  const selectedClass = vehicleClasses.find((item) => item.id === id || item.value === id);
  return selectedClass;
};